import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import SecuritizationHero from "./SecuritizationHero";
import SecurityTokenOffering from "./SecurityTokenOffering";
import STODev from "./STODev";
import TokenCreation from "./TokenCreation";

function Securitization() {
  return (
    <div>
      <Header />
      <SecuritizationHero />
      <SecurityTokenOffering />
      <STODev />
      <TokenCreation />
      <Footer />
    </div>
  );
}

export default Securitization;
